import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-databank-new',
  templateUrl: './databank-new.component.html',
  styleUrls: ['./databank-new.component.css']
})
export class DatabankNewComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
